<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Montant à payer</h4>
    </div>
    <div class="modal-body">
      <div class="row"
           style="margin-bottom: 20px;">
        <div class="col-sm-12">
          <h4>Montant</h4>
          <div class="input-group m-b">
            <input type="number"
                  placeholder="Choisissez un montant à payer"
                  class="form-control"
                  v-model="amount">
            <span class="input-group-addon">€</span>
          </div>
        </div>
        <div class="col-sm-12">
          <h4>Les informations du client</h4>
          <div class="greenBox mt20">
            <h4><i class="fa fa-user"></i> {{ model.command.buyer[0].firstname }} {{ model.command.buyer[0].lastname }}</h4>
            <p>
              <i class="fa fa-envelope"></i> Email: {{ model.command.buyer[0].email }} <br>
              <i class="fa fa-map-marker"></i> Adresse: {{ model.command.buyer[0].address.address }}, {{ model.command.buyer[0].address.zipCode }}, {{ model.command.buyer[0].address.city }} <br>
              <i class="fa fa-phone"></i> Contact: {{ model.command.buyer[0].phone }}
            </p> 
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-center">
      <button type="button"
              class="btn btn-default"
              @click="closeModal">Annuler</button>
      <button type="button"
              class="btn btn-primary"
              :disabled="!amount"
              @click="onSubmit">Procéder</button>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'

  export default {
    name: "CreditWallet",

    data: () => ({
      store,
      amount: ""
    }),

    computed: {
      model () {
        return store.modal.dataModel
      }
    },

    methods: {
      onSubmit () {
        this.$bus.$emit('credit-wallet-success', this.amount)
        this.closeModal()
      }
    }
  }
</script>
